import axios from 'axios';

// 导出基础URL以便其他组件使用
export const BASE_URL = 'https://web.comicshort.cn';

const api = axios.create({
  baseURL: BASE_URL,
  timeout: 15000
});

// 获取首页轮播图
export function getHomeBanner() {
  return api.get('/api/banner');
}

// 获取漫画列表
export function getComicList(params) {
  return api.get('/api/comic', { params });
}

// 获取分类漫画列表
export function getCategoryComics(params) {
  return api.get('/api/comic', { params });
}

// 获取热榜漫画列表
export function getRankingComics(params) {
  return api.get('/api/comic', { params });
}

// 获取今日更新漫画列表
export function getUpdateComics(params) {
  return api.get('/api/comic', { params });
}

// 获取漫画详情
export function getComicDetail(id) {
  return api.get(`/api/comic/detail`, { params: { id } });
}

// 获取章节详情
export function getChapterDetail(id) {
  const token = localStorage.getItem('userToken');
  console.log('[API] getChapterDetail 请求开始 - 参数:', id);
  console.log('[API] getChapterDetail 使用Token:', token ? '已提供' : '未提供');
  const startTime = Date.now();
  
  return api.get('/api/chapter/detail', { 
    params: { 
      id,
      token: token || '' 
    } 
  }).then(res => {
    const endTime = Date.now();
    console.log(`[API] getChapterDetail 请求完成 - 耗时: ${endTime - startTime}ms`);
    console.log('[API] getChapterDetail 返回状态码:', res.data.code);
    console.log('[API] getChapterDetail 返回信息:', res.data.msg);
    
    if (res.data.code === 1) {
      const data = res.data.data;
      console.log('[API] getChapterDetail 章节信息:', JSON.stringify(data.chapter));
      console.log('[API] getChapterDetail 漫画信息:', JSON.stringify({
        id: data.comic.id,
        title: data.comic.title,
        author: data.comic.author
      }));
      
      // 详细记录内容信息
      if (data.content && data.content.content) {
        console.log('[API] getChapterDetail 内容类型:', data.content.type);
        console.log('[API] getChapterDetail 内容页数:', data.content.content.length);
        console.log('[API] getChapterDetail 图片样本:', JSON.stringify(data.content.content.slice(0, 2)));
        
        // 检查图片路径格式
        const hasRelativePaths = data.content.content.some(path => !path.startsWith('http'));
        console.log('[API] getChapterDetail 图片路径类型:', hasRelativePaths ? '包含相对路径' : '全部为完整URL');
      } else {
        console.log('[API] getChapterDetail 无内容数据或内容为空');
      }
      
      // 记录访问权限信息
      console.log('[API] getChapterDetail 访问权限:', JSON.stringify(data.accessInfo));
    } else {
      console.error('[API] getChapterDetail 返回错误:', res.data);
    }
    
    return res;
  }).catch(error => {
    console.error('[API] getChapterDetail 请求失败:', error);
    throw error;
  });
}

// 获取章节列表
export function getChapterList(params) {
  const token = localStorage.getItem('userToken');
  const updatedParams = { ...params, token: token || '' };
  
  console.log('[API] getChapterList 请求开始 - 参数:', JSON.stringify(updatedParams));
  console.log('[API] getChapterList 使用Token:', token ? '已提供' : '未提供');
  const startTime = Date.now();
  
  return api.get('/api/chapter/list', { params: updatedParams }).then(res => {
    const endTime = Date.now();
    console.log(`[API] getChapterList 请求完成 - 耗时: ${endTime - startTime}ms`);
    console.log('[API] getChapterList 返回状态码:', res.data.code);
    console.log('[API] getChapterList 返回信息:', res.data.msg);
    
    if (res.data.code === 1) {
      const chapters = res.data.data.list || [];
      console.log('[API] getChapterList 章节数量:', chapters.length);
      
      if (chapters.length > 0) {
        console.log('[API] getChapterList 首章信息:', JSON.stringify(chapters[0]));
        console.log('[API] getChapterList 尾章信息:', JSON.stringify(chapters[chapters.length - 1]));
      } else {
        console.warn('[API] getChapterList 返回空章节列表');
      }
    } else {
      console.error('[API] getChapterList 返回错误:', JSON.stringify(res.data));
    }
    
    return res;
  }).catch(error => {
    console.error('[API] getChapterList 请求失败:', error);
    throw error;
  });
}

// 用户注册
export function userRegister(data) {
  return api.post('/api/user/register', data);
}

// 短信验证码注册
export function smsRegister(data) {
  return api.post('/api/user/sms_register', data);
}

// 用户登录
export function userLogin(data) {
  return api.post('/api/user/login', data);
}

// 短信验证码登录
export function smsLogin(data) {
  return api.post('/api/user/mobilelogin', data);
}

// 获取个人信息
export function getUserInfo() {
  const token = localStorage.getItem('userToken');
  return api.get(`/api/user/index?token=${token}`);
}

// 实名认证（支持身份证图片上传）
export function realnameVerify(formData) {
  const token = localStorage.getItem('userToken');
  return api.post(`/api/user/realname_verify?token=${token}`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
}

// 发送短信验证码
export function sendSmsCode(mobile, event = 'register') {
  return api.post('/api/sms/send', { mobile, event }, { timeout: 15000 }).then(res => {
    // 适配后端返回格式 {code: 1, msg: "发送成功"}
    if (res.data && res.data.code === 1) {
      return { success: true, message: res.data.msg };
    } else {
      const msg = (res.data && res.data.msg) || '发送失败';
      return { success: false, message: msg };
    }
  }).catch(error => {
    if (error && error.message === 'timeout of 15000ms exceeded') {
      return { success: false, message: '请求超时，请稍后重试' };
    }
    return { success: false, message: error && error.message ? error.message : '发送失败，请稍后重试' };
  });
}

// 验证短信验证码
export function checkSmsCode(mobile, captcha, event = 'register') {
  return api.post('/api/sms/check', { mobile, captcha, event }).then(res => {
    // 适配后端返回格式 {code: 1, msg: "成功"}
    if (res.data.code === 1) {
      return { success: true, message: res.data.msg };
    } else {
      return { success: false, message: res.data.msg || '验证失败' };
    }
  });
}

// 帮助中心API
export function getHelpCategories() {
  return api.get('/api/help/categories');
}

export function getHelpArticles(categoryId) {
  return api.get('/api/help/articles', { params: { category_id: categoryId } });
}

export function getHelpDetail(id) {
  return api.get('/api/help/detail', { params: { id } });
}

export function searchHelp(keyword) {
  return api.get('/api/help/search', { params: { keyword } });
}

export function getHotHelp() {
  return api.get('/api/help/hot');
}

// 获取用户VIP状态
export function getUserVipInfo() {
  const token = localStorage.getItem('userToken');
  return api.get(`/api/vip/info?token=${token}`);
}

// 投稿相关API

// 获取分类列表
export function getSubmissionCategories() {
  const token = localStorage.getItem('userToken');
  return api.get(`/api/submission/categories?token=${token || ''}`);
}

// 创建投稿
export function createSubmission(submissionData) {
  const token = localStorage.getItem('userToken');
  return api.post(`/api/submission/create?token=${token || ''}`, submissionData);
}

// 添加章节
export function addChapter(submissionId, chapterData) {
  const token = localStorage.getItem('userToken');
  return api.post(`/api/submission/addChapter?token=${token || ''}`, {
    submission_id: submissionId,
    row: chapterData
  });
}

// 投稿管理相关API

// 获取用户投稿列表
export function getUserSubmissions(params = {}) {
  const token = localStorage.getItem('userToken');
  const queryParams = new URLSearchParams({
    token: token || '',
    page: params.page || 1,
    limit: params.limit || 10,
    ...(params.audit_status && { audit_status: params.audit_status })
  });
  return api.get(`/api/submission/index?${queryParams}`);
}

// 获取投稿详情
export function getSubmissionDetail(id) {
  const token = localStorage.getItem('userToken');
  return api.get(`/api/submission/detail?id=${id}&token=${token || ''}`);
}

// 编辑投稿
export function editSubmission(id, updateData) {
  const token = localStorage.getItem('userToken');
  return api.post(`/api/submission/edit?token=${token || ''}`, {
    id: id,
    row: updateData
  });
}

// 删除投稿
export function deleteSubmission(id) {
  const token = localStorage.getItem('userToken');
  return api.post(`/api/submission/delete?token=${token || ''}`, {
    id: id
  });
}

// 获取投稿的章节列表
export function getSubmissionChapters(submissionId) {
  const token = localStorage.getItem('userToken');
  return api.get(`/api/submission/chapters?submission_id=${submissionId}&token=${token || ''}`);
}

// 文件上传API
export function uploadFile(file, options = {}) {
  const token = localStorage.getItem('userToken');
  const formData = new FormData();

  // 添加文件
  formData.append('file', file);

  // 添加可选参数
  if (options.category) {
    formData.append('category', options.category);
  }
  if (options.filename) {
    formData.append('filename', options.filename);
  }
  if (options.chunk !== undefined) {
    formData.append('chunk', options.chunk);
  }
  if (options.chunksize) {
    formData.append('chunksize', options.chunksize);
  }
  if (options.chunkcount) {
    formData.append('chunkcount', options.chunkcount);
  }

  // 添加token
  formData.append('token', token || '');

  return api.post('/api/common/upload', formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    // 支持上传进度回调
    onUploadProgress: options.onProgress
  });
}

// 使用金币购买章节
export function buyChapter(chapterId) {
  const token = localStorage.getItem('userToken');
  console.log('[API] buyChapter 请求开始 - 参数:', { chapter_id: chapterId });
  console.log('[API] buyChapter 使用Token:', token ? '已提供' : '未提供');
  
  if (!token) {
    console.error('[API] buyChapter 失败: 未提供token');
    return Promise.reject(new Error('未登录或token无效'));
  }
  
  if (!chapterId) {
    console.error('[API] buyChapter 失败: 未提供章节ID');
    return Promise.reject(new Error('章节ID不能为空'));
  }
  
  const startTime = Date.now();
  
  // 使用URL参数传递token
  return api.post(`/api/chapter/buy?token=${token}`, { 
    chapter_id: Number(chapterId) // 确保章节ID是整数类型
  }).then(res => {
    const endTime = Date.now();
    console.log(`[API] buyChapter 请求完成 - 耗时: ${endTime - startTime}ms`);
    console.log('[API] buyChapter 返回状态码:', res.data.code);
    console.log('[API] buyChapter 返回信息:', res.data.msg);
    
    if (res.data.code === 1) {
      console.log('[API] buyChapter 购买成功');
    } else {
      console.error('[API] buyChapter 购买失败:', res.data);
    }
    
    return res;
  }).catch(error => {
    console.error('[API] buyChapter 请求失败:', error);
    console.error('[API] buyChapter 错误详情:', error.message);
    if (error.response) {
      console.error('[API] buyChapter 响应状态:', error.response.status);
      console.error('[API] buyChapter 响应数据:', error.response.data);
    }
    throw error;
  });
}


   
// 获取单个类型的内容（关于我们、联系我们、用户协议、隐私政策）
export function getAboutContent(type = 'about') {
  console.log('[API] getAboutContent 请求开始 - 类型:', type);
  const startTime = Date.now();
  
  return api.get('/api/about/index', { 
    params: { type } 
  }).then(res => {
    const endTime = Date.now();
    console.log(`[API] getAboutContent 请求完成 - 耗时: ${endTime - startTime}ms`);
    console.log('[API] getAboutContent 返回状态码:', res.data.code);
    
    if (res.data.code === 1) {
      console.log('[API] getAboutContent 获取成功 - 标题:', res.data.data.title);
    } else {
      console.error('[API] getAboutContent 获取失败:', res.data);
    }
    
    return res;
  }).catch(error => {
    console.error('[API] getAboutContent 请求失败:', error);
    throw error;
  });
}

// 获取VIP套餐列表
export function getVipPackages() {
  console.log('[API] getVipPackages 请求开始');
  const startTime = Date.now();
  
  return api.get('/api/vip/packages').then(res => {
    const endTime = Date.now();
    console.log(`[API] getVipPackages 请求完成 - 耗时: ${endTime - startTime}ms`);
    console.log('[API] getVipPackages 返回状态码:', res.data.code);
    
    if (res.data.code === 1) {
      console.log('[API] getVipPackages 获取成功 - 套餐数量:', res.data.data.length);
    } else {
      console.error('[API] getVipPackages 获取失败:', res.data);
    }
    
    return res;
  }).catch(error => {
    console.error('[API] getVipPackages 请求失败:', error);
    throw error;
  });
}

// 获取金币套餐列表
export function getCoinPackages() {
  console.log('[API] getCoinPackages 请求开始');
  const startTime = Date.now();
  
  return api.get('/api/coin/packages').then(res => {
    const endTime = Date.now();
    console.log(`[API] getCoinPackages 请求完成 - 耗时: ${endTime - startTime}ms`);
    console.log('[API] getCoinPackages 返回状态码:', res.data.code);
    
    if (res.data.code === 1) {
      console.log('[API] getCoinPackages 获取成功 - 套餐数量:', res.data.data.length);
    } else {
      console.error('[API] getCoinPackages 获取失败:', res.data);
    }
    
    return res;
  }).catch(error => {
    console.error('[API] getCoinPackages 请求失败:', error);
    throw error;
  });
}

// 阅读进度管理工具类
export class ReadingProgressManager {
  static STORAGE_KEY = 'readingHistory';
  static MAX_HISTORY_COUNT = 50; // 最多保存50条阅读记录

  // 保存阅读进度
  static saveProgress(comicId, chapterId, chapterTitle, comicTitle, currentPage, totalPages, coverImage = '') {
    try {
      let history = this.getHistory();
      const timestamp = Date.now();

      // 查找是否已存在该漫画的记录（按漫画ID查找，保留最新章节）
      const existingIndex = history.findIndex(item => item.comicId === Number(comicId));

      const progressData = {
        comicId: Number(comicId),
        chapterId: Number(chapterId),
        title: comicTitle || '未知漫画',
        chapterTitle: chapterTitle || '未知章节',
        currentPage: Number(currentPage),
        totalPages: Number(totalPages),
        lastReadTime: timestamp,
        coverImage: coverImage || ''
      };

      if (existingIndex !== -1) {
        // 更新现有记录
        history[existingIndex] = progressData;
        console.log('[ReadingProgress] 更新阅读进度:', progressData);
      } else {
        // 添加新记录到开头
        history.unshift(progressData);
        console.log('[ReadingProgress] 新增阅读进度:', progressData);
      }

      // 限制历史记录数量
      if (history.length > this.MAX_HISTORY_COUNT) {
        history.splice(this.MAX_HISTORY_COUNT);
      }

      // 按最后阅读时间排序
      history.sort((a, b) => b.lastReadTime - a.lastReadTime);

      localStorage.setItem(this.STORAGE_KEY, JSON.stringify(history));

      return progressData;
    } catch (error) {
      console.error('[ReadingProgress] 保存阅读进度失败:', error);
      return null;
    }
  }

  // 获取阅读历史
  static getHistory() {
    try {
      const history = localStorage.getItem(this.STORAGE_KEY);
      return history ? JSON.parse(history) : [];
    } catch (error) {
      console.error('[ReadingProgress] 获取阅读历史失败:', error);
      return [];
    }
  }

  // 获取特定漫画的阅读进度
  static getComicProgress(comicId, chapterId = null) {
    try {
      const history = this.getHistory();
      if (chapterId) {
        return history.find(item =>
          item.comicId === Number(comicId) && item.chapterId === Number(chapterId)
        );
      } else {
        // 返回该漫画最新的阅读记录
        return history.find(item => item.comicId === Number(comicId));
      }
    } catch (error) {
      console.error('[ReadingProgress] 获取漫画进度失败:', error);
      return null;
    }
  }

  // 删除阅读记录
  static removeProgress(id) {
    try {
      const history = this.getHistory();
      const filteredHistory = history.filter(item => item.id !== id);
      localStorage.setItem(this.STORAGE_KEY, JSON.stringify(filteredHistory));
      console.log('[ReadingProgress] 删除阅读记录:', id);
      return true;
    } catch (error) {
      console.error('[ReadingProgress] 删除阅读记录失败:', error);
      return false;
    }
  }

  // 清空所有阅读历史
  static clearHistory() {
    try {
      localStorage.removeItem(this.STORAGE_KEY);
      console.log('[ReadingProgress] 清空阅读历史');
      return true;
    } catch (error) {
      console.error('[ReadingProgress] 清空阅读历史失败:', error);
      return false;
    }
  }

  // 获取阅读统计信息
  static getReadingStats() {
    try {
      const history = this.getHistory();
      const totalComics = new Set(history.map(item => item.comicId)).size;
      const totalChapters = history.length;
      const completedChapters = history.filter(item => item.isCompleted).length;
      const totalReadingTime = history.reduce((total, item) => {
        // 估算阅读时间：每页2分钟
        return total + (item.currentPage * 2);
      }, 0);

      return {
        totalComics,
        totalChapters,
        completedChapters,
        totalReadingTime, // 分钟
        averageProgress: totalChapters > 0 ?
          Math.round(history.reduce((sum, item) => sum + item.progress, 0) / totalChapters) : 0
      };
    } catch (error) {
      console.error('[ReadingProgress] 获取阅读统计失败:', error);
      return {
        totalComics: 0,
        totalChapters: 0,
        completedChapters: 0,
        totalReadingTime: 0,
        averageProgress: 0
      };
    }
  }
}

// 评论管理工具类
export class CommentManager {
  static STORAGE_KEY = 'comicComments';
  static MAX_COMMENTS_PER_COMIC = 100; // 每个漫画最多100条评论

  // 获取漫画的所有评论
  static getComments(comicId) {
    try {
      const allComments = localStorage.getItem(this.STORAGE_KEY);
      const comments = allComments ? JSON.parse(allComments) : {};
      return comments[comicId] || [];
    } catch (error) {
      console.error('[CommentManager] 获取评论失败:', error);
      return [];
    }
  }

  // 添加评论
  static addComment(comicId, content, rating = 5) {
    try {
      const username = localStorage.getItem('username') || '匿名用户';
      const userToken = localStorage.getItem('userToken');

      if (!userToken) {
        throw new Error('请先登录后再评论');
      }

      const allComments = localStorage.getItem(this.STORAGE_KEY);
      const comments = allComments ? JSON.parse(allComments) : {};

      if (!comments[comicId]) {
        comments[comicId] = [];
      }

      const newComment = {
        id: Date.now().toString(),
        comicId: Number(comicId),
        username: username,
        content: content.trim(),
        rating: Number(rating),
        timestamp: Date.now(),
        likes: 0,
        replies: []
      };

      // 添加到开头
      comments[comicId].unshift(newComment);

      // 限制评论数量
      if (comments[comicId].length > this.MAX_COMMENTS_PER_COMIC) {
        comments[comicId] = comments[comicId].slice(0, this.MAX_COMMENTS_PER_COMIC);
      }

      localStorage.setItem(this.STORAGE_KEY, JSON.stringify(comments));
      console.log('[CommentManager] 评论添加成功:', newComment);

      return newComment;
    } catch (error) {
      console.error('[CommentManager] 添加评论失败:', error);
      throw error;
    }
  }

  // 删除评论
  static deleteComment(comicId, commentId) {
    try {
      const allComments = localStorage.getItem(this.STORAGE_KEY);
      const comments = allComments ? JSON.parse(allComments) : {};

      if (comments[comicId]) {
        comments[comicId] = comments[comicId].filter(comment => comment.id !== commentId);
        localStorage.setItem(this.STORAGE_KEY, JSON.stringify(comments));
        console.log('[CommentManager] 评论删除成功:', commentId);
        return true;
      }

      return false;
    } catch (error) {
      console.error('[CommentManager] 删除评论失败:', error);
      return false;
    }
  }

  // 点赞评论
  static likeComment(comicId, commentId) {
    try {
      const allComments = localStorage.getItem(this.STORAGE_KEY);
      const comments = allComments ? JSON.parse(allComments) : {};

      if (comments[comicId]) {
        const comment = comments[comicId].find(c => c.id === commentId);
        if (comment) {
          comment.likes = (comment.likes || 0) + 1;
          localStorage.setItem(this.STORAGE_KEY, JSON.stringify(comments));
          console.log('[CommentManager] 点赞成功:', commentId);
          return comment.likes;
        }
      }

      return 0;
    } catch (error) {
      console.error('[CommentManager] 点赞失败:', error);
      return 0;
    }
  }

  // 添加回复
  static addReply(comicId, commentId, content) {
    try {
      const username = localStorage.getItem('username') || '匿名用户';
      const userToken = localStorage.getItem('userToken');

      if (!userToken) {
        throw new Error('请先登录后再回复');
      }

      const allComments = localStorage.getItem(this.STORAGE_KEY);
      const comments = allComments ? JSON.parse(allComments) : {};

      if (comments[comicId]) {
        const comment = comments[comicId].find(c => c.id === commentId);
        if (comment) {
          const newReply = {
            id: Date.now().toString(),
            username: username,
            content: content.trim(),
            timestamp: Date.now()
          };

          if (!comment.replies) {
            comment.replies = [];
          }

          comment.replies.push(newReply);
          localStorage.setItem(this.STORAGE_KEY, JSON.stringify(comments));
          console.log('[CommentManager] 回复添加成功:', newReply);

          return newReply;
        }
      }

      return null;
    } catch (error) {
      console.error('[CommentManager] 添加回复失败:', error);
      throw error;
    }
  }

  // 获取评论统计
  static getCommentStats(comicId) {
    try {
      const comments = this.getComments(comicId);
      const totalComments = comments.length;
      const totalReplies = comments.reduce((sum, comment) => sum + (comment.replies?.length || 0), 0);
      const averageRating = totalComments > 0 ?
        comments.reduce((sum, comment) => sum + (comment.rating || 5), 0) / totalComments : 0;

      return {
        totalComments,
        totalReplies,
        averageRating: Math.round(averageRating * 10) / 10,
        totalInteractions: totalComments + totalReplies
      };
    } catch (error) {
      console.error('[CommentManager] 获取评论统计失败:', error);
      return {
        totalComments: 0,
        totalReplies: 0,
        averageRating: 0,
        totalInteractions: 0
      };
    }
  }

  // 清空漫画的所有评论
  static clearComments(comicId) {
    try {
      const allComments = localStorage.getItem(this.STORAGE_KEY);
      const comments = allComments ? JSON.parse(allComments) : {};

      if (comments[comicId]) {
        delete comments[comicId];
        localStorage.setItem(this.STORAGE_KEY, JSON.stringify(comments));
        console.log('[CommentManager] 清空评论成功:', comicId);
        return true;
      }

      return false;
    } catch (error) {
      console.error('[CommentManager] 清空评论失败:', error);
      return false;
    }
  }
}

// 修改用户资料
export function updateUserProfile(profileData) {
  const token = localStorage.getItem('userToken');
  return api.post(`/api/user/profile?token=${token}`, profileData);
}

// 青少年保护模式 API

// 获取配置
export function getYouthConfig() {
  const token = localStorage.getItem('userToken');
  return api.get(`/api/youth_mode/getConfig?token=${token}`);
}

// 更新配置
export function setYouthConfig(data) {
  const token = localStorage.getItem('userToken');
  return api.post(`/api/youth_mode/setConfig?token=${token}`, data);
}

// 设置独立密码（修改密码时必须传 oldPassword，后端强制校验）
export function setYouthPassword(password, oldPassword) {
  const token = localStorage.getItem('userToken');
  const payload = { password };
  if (oldPassword) payload.old_password = oldPassword;
  return api.post(`/api/youth_mode/setPassword?token=${token}`, payload);
}

// 验证独立密码
export function verifyYouthPassword(password) {
  const token = localStorage.getItem('userToken');
  return api.post(`/api/youth_mode/verifyPassword?token=${token}`, { password });
}

// 获取使用情况
export function getYouthUsage() {
  const token = localStorage.getItem('userToken');
  return api.get(`/api/youth_mode/getUsage?token=${token}`);
}

// 增加使用时长
export function addYouthUsage(minutes = 1) {
  const token = localStorage.getItem('userToken');
  return api.post(`/api/youth_mode/addUsage?token=${token}`, { minutes });
}

// 访问控制检查
export function checkYouthAccess() {
  const token = localStorage.getItem('userToken');
  return api.get(`/api/youth_mode/checkAccess?token=${token}`);
}

// 投诉举报
export function submitReport(data) {
  const token = localStorage.getItem('userToken');
  return api.post(`/api/report/submit?token=${token}`, data);
}


// 解锁30分钟
export function unlockYouth(password) {
  const token = localStorage.getItem('userToken');
  return api.post(`/api/youth_mode/unlock?token=${token}`, { password });
}

// 检查是否已解锁
export function isYouthUnlocked() {
  const token = localStorage.getItem('userToken');
  return api.get(`/api/youth_mode/isUnlocked?token=${token}`);
}

/* ==================== 签到 Sign / Check-in ==================== */

// 获取签到状态（今日是否已签、连续天数、本月签到日期、奖励规则）
export function getSignStatus() {
  const token = localStorage.getItem('userToken');
  return api.get(`/api/sign/status?token=${token || ''}`);
}

// 执行签到
export function doSignIn() {
  const token = localStorage.getItem('userToken');
  return api.post(`/api/sign/doSign?token=${token || ''}`);
}

// 补签（消耗金币）
export function repairSign(date) {
  const token = localStorage.getItem('userToken');
  return api.post(`/api/sign/repair?token=${token || ''}`, { date });
}

/* ==================== 通知 Notification ==================== */

// 未读消息数量
export function getUnreadCount() {
  const token = localStorage.getItem('userToken');
  return api.get(`/api/notice/unread?token=${token || ''}`);
}

// 通知列表（type: all/system/audit/unlock ...）
export function getNotifications(params = {}) {
  const token = localStorage.getItem('userToken');
  const query = new URLSearchParams({
    token: token || '',
    page: params.page || 1,
    limit: params.limit || 15,
    ...(params.type && params.type !== 'all' ? { type: params.type } : {})
  });
  return api.get(`/api/notice/index?${query}`);
}

// 标记单条已读
export function markNoticeRead(id) {
  const token = localStorage.getItem('userToken');
  return api.post(`/api/notice/read?token=${token || ''}`, { id });
}

// 全部标记已读
export function markAllNoticeRead() {
  const token = localStorage.getItem('userToken');
  return api.post(`/api/notice/readAll?token=${token || ''}`);
}

// 删除通知
export function deleteNotice(id) {
  const token = localStorage.getItem('userToken');
  return api.post(`/api/notice/delete?token=${token || ''}`, { id });
}

/* ==================== 阅读进度 Reading ==================== */

// 保存阅读进度
export function saveReadingProgress(data) {
  const token = localStorage.getItem('userToken');
  return api.post(`/api/reading/save?token=${token || ''}`, data);
}

// 获取某漫画阅读进度
export function getReadingProgress(comicId) {
  const token = localStorage.getItem('userToken');
  return api.get(`/api/reading/detail?token=${token || ''}&comic_id=${comicId}`);
}

// 获取阅读历史列表
export function getReadingHistory(params = {}) {
  const token = localStorage.getItem('userToken');
  const query = new URLSearchParams({
    token: token || '',
    page: params.page || 1,
    limit: params.limit || 20
  });
  return api.get(`/api/reading/index?${query}`);
}

// 删除阅读记录
export function deleteReadingProgress(comicId) {
  const token = localStorage.getItem('userToken');
  return api.post(`/api/reading/delete?token=${token || ''}`, { comic_id: comicId });
}

/* ==================== 收藏 Favorite ==================== */

// 切换收藏状态
export function toggleFavorite(comicId) {
  const token = localStorage.getItem('userToken');
  return api.post(`/api/favorite/toggle?token=${token || ''}`, { comic_id: comicId });
}

// 获取收藏状态
export function getFavoriteStatus(comicId) {
  const token = localStorage.getItem('userToken');
  return api.get(`/api/favorite/status?token=${token || ''}&comic_id=${comicId}`);
}

// 获取收藏列表
export function getFavorites(params = {}) {
  const token = localStorage.getItem('userToken');
  const query = new URLSearchParams({
    token: token || '',
    page: params.page || 1,
    limit: params.limit || 20
  });
  return api.get(`/api/favorite/index?${query}`);
}

/* ==================== 评论 Comment ==================== */

// 发表评论
export function addComment(data) {
  const token = localStorage.getItem('userToken');
  return api.post(`/api/comment/add?token=${token || ''}`, data);
}

// 获取漫画评论列表
export function getComments(comicId, params = {}) {
  const token = localStorage.getItem('userToken');
  const query = new URLSearchParams({
    comic_id: comicId,
    page: params.page || 1,
    limit: params.limit || 10
  });
  return api.get(`/api/comment/list?token=${token || ''}&${query}`);
}

// 获取我的评论
export function getMyComments(params = {}) {
  const token = localStorage.getItem('userToken');
  const query = new URLSearchParams({
    token: token || '',
    page: params.page || 1,
    limit: params.limit || 20
  });
  return api.get(`/api/comment/my?${query}`);
}

// 回复评论
export function addReply(commentId, content) {
  const token = localStorage.getItem('userToken');
  return api.post(`/api/comment/reply?token=${token || ''}`, { comment_id: commentId, content });
}

// 点赞评论
export function likeCommentApi(commentId) {
  const token = localStorage.getItem('userToken');
  return api.post(`/api/comment/like?token=${token || ''}`, { comment_id: commentId });
}

// 删除评论
export function deleteCommentApi(commentId) {
  const token = localStorage.getItem('userToken');
  return api.post(`/api/comment/delete?token=${token || ''}`, { comment_id: commentId });
}

/* ==================== 购买历史 Purchase ==================== */

// 获取当前用户购买历史
export function getPurchaseHistory(params = {}) {
  const token = localStorage.getItem('userToken');
  const query = new URLSearchParams({
    token: token || '',
    page: params.page || 1,
    limit: params.limit || 20
  });
  return api.get(`/api/purchase/history?${query.toString()}`);
}

// 记录购买行为（支付成功时调用）
export function recordPurchase(data) {
  const token = localStorage.getItem('userToken');
  return api.post(`/api/purchase/record?token=${token || ''}`, data);
}

// 获取当前用户购买的漫画章节记录
export function getPurchasedChapters(params = {}) {
  const token = localStorage.getItem('userToken');
  const query = new URLSearchParams({
    token: token || '',
    page: params.page || 1,
    limit: params.limit || 20
  });
  return api.get(`/api/chapter/purchased?${query.toString()}`);
}

/* ==================== 作者认证 Author ==================== */

// 获取当前用户作者认证状态
export function getAuthorStatus() {
  const token = localStorage.getItem('userToken');
  return api.get(`/api/author/status?token=${token || ''}`);
}

// 提交作者认证申请
export function applyAuthor(data) {
  const token = localStorage.getItem('userToken');
  return api.post(`/api/author/apply?token=${token || ''}`, data);
}

export default api;